export const LAPLACE_QUERY_KEY_PREFIX = "laplace";
